export const SAVE_PARAMETERS_STATE = 'SAVE_PARAMETERS_STATE';
export const SAVE_VARIABLE_STATE = 'SAVE_VARIABLE_STATE';
export const VARIABLES_OR_PARAMETER_STATE_UPDATE = 'VARIABLES_OR_PARAMETER_STATE_UPDATE';
export const SET_ACTUAL = 'SET_ACTUAL';
export const SET_INITIAL = 'SET_INITIAL';
export const ACTIVE_TAB = 'ACTIVE_TAB';
export const MODEL_RESET_ORIGINAL_VALUES = 'MODEL_RESET_ORIGINAL_VALUES';

const revenueParametersAction = (payload) => ({
    type: SAVE_PARAMETERS_STATE,
    rpPayload: payload,
});

const inputVariablesAction = (payload) => ({
    type: SAVE_VARIABLE_STATE,
    ivPayload: payload,
});

const setModelActualAction = (payload) => ({
    type: SET_ACTUAL,
    actual: payload,
});

const setModelInitialAction = (payload) => ({
    type: SET_INITIAL,
    initial: payload,
});

const setActiveTabAction = (payload) => ({
    type: ACTIVE_TAB,
    activeTab: payload,
});

const isParametersOrVariablesUpdatedAction = (payload) => ({
    type: VARIABLES_OR_PARAMETER_STATE_UPDATE,
    status: payload.status,
    group: payload.group,
});

const resetOriginalValuesAction = (payload) => ({
    type: MODEL_RESET_ORIGINAL_VALUES,
    flag: payload,
});

export {
    revenueParametersAction,
    inputVariablesAction,
    setModelInitialAction,
    setModelActualAction,
    setActiveTabAction,
    isParametersOrVariablesUpdatedAction,
    resetOriginalValuesAction,
};
